import type { GenericObject } from '~/types/common'

export const sortByNumericName = <T extends GenericObject = GenericObject>(items: T[], key: keyof T): T[] => {
  return [...items].sort((a, b) => {
    const aValue = String(a[key])
    const bValue = String(b[key])
    const aNumber = parseInt(aValue, 10)
    const bNumber = parseInt(bValue, 10)

    if (isNaN(aNumber) || isNaN(bNumber)) {
      return aValue.localeCompare(bValue)
    }

    return aNumber - bNumber
  })
}
